import { contaInvestimento } from '@constants/URL'
import con from '@services/connection'

class APIContaBancaria {
  async salvarContaNaoAutomatica({ id_banco, conta }, cliente, usuarioAtual) {
    const data = {
      id_banco,
      conta,
    }

    let url = usuarioAtual.IS_CLIENTE
      ? contaInvestimento.addContaNaoAutomatica.cliente
      : contaInvestimento.addContaNaoAutomatica.profissional + cliente.id

    const r = await con.post(url, data)

    // value: id_conta
    return r || {}
  }
}

const apiContaBancaria = new APIContaBancaria()
export default apiContaBancaria
